import * as constants from './genericAction.contants';

export const getCustomAppScreensData = () => ({ type: constants.GET_CUSTOM_APP_SCREENS_DATA });
export const getCustomWebViewsData = () => ({ type: constants.GET_CUSTOM_WEB_VIEWS_DATA });
export const getCatalogs = () => ({ type: constants.GET_CATALOGS });
